export default __webpack_public_path__ + "assets/80e057fa20d04ef1990fe39d5b19b6d8.png";